import React from 'react';

const Header = ({ onOpenHistory }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-gray-100">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-gray-100">
            <span className="text-gray-700 text-xl">🔄</span>
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Gestión de Devoluciones</h1>
            <p className="text-gray-600 text-sm">Procesa devoluciones de manera segura y eficiente</p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onOpenHistory}
            className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors text-sm"
          >
            📊 Historial Avanzado
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
